import request from '@/utils/request'

//获取OAuth状态
export function getOauthStatus() {
  return request({
    url: '/jd/oauth/status',
    method: 'get',
  })
}

//获取code
export function getLoginUrl() {
  return request({
    url: '/jd/oauth/login-url',
    method: 'get',
  })
}

//获取code
export function getCallbackCode(code,state) {
  return request({
    url: '/jd/oauth/callback?code=' + code + "&state=" + state,
    method: 'get',
  })
}

//京东审方列表分页
export function getJdPrescriptionPage(query) {
  return request({
    url: '/jd/prescription/page',
    method: 'get',
    params: query
  })
}

//京东审方状态变更（通过/驳回）
export function statusChange(data) {
  return request({
    url: '/jd/prescription/statusChange',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/jdRequest.js